import globalStyles from '../../styles/exported.module.scss';
import { svgIconsTestIds } from '../tests/testIds';

export const SearchIcon = ({ className, ...rest }: { className?: string } & Partial<HTMLOrSVGElement>) => (
  <svg
    {...(className && { className })}
    {...rest}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    data-testid={svgIconsTestIds.searchIcon}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 7.5C13.75 10.8135 11.0635 13.5 7.75 13.5C4.4365 13.5 1.75 10.8135 1.75 7.5C1.75 4.1865 4.4365 1.5 7.75 1.5C11.0635 1.5 13.75 4.1865 13.75 7.5Z"
      stroke={globalStyles.bdNeutralDarkGray}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.75 16.5L12.25 12"
      stroke={globalStyles.bdNeutralDarkGray}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
